module.exports = __webpack_public_path__ + "static/media/img_set_password2.785f42fb.jpg";